module.exports = __webpack_public_path__ + "static/media/step-1.ae184b48.webp";